<standard-nav-shell
  [scrollActiveNavItemIntoView]="true"
  class="d-flex flex-column min-vh-100"
  style="--bs-h-header: var(--bs-h-shell-header)"
  topStyleClass="fixed-top shadow-sm"
  bottomColorMode="dark"
  [showClose]="true"
  [defaultSideCollapsedMaxSize]="MAX_SAFE_INTEGER"
  [sideOverlayFullMaxSize]="MAX_SAFE_INTEGER"
  [autoShowSideNavCutoffMinSize]="MAX_SAFE_INTEGER"
>
  <ng-template #register let-registerNavTemplates="registerNavTemplates">
    <standard-lazy-component
      [content]="navContent$().content"
      [lazyProps]="{
        registerNavTemplates: registerNavTemplates,
      }"
    >
      <ng-template #skeleton>
        <nav
          class="navbar navbar-expand navbar-light bg-body border-bottom h-header"
        ></nav>
      </ng-template>
    </standard-lazy-component>
  </ng-template>

  <div style="margin-top: var(--bs-h-header)">
    <ng-content />
  </div>
</standard-nav-shell>
